import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=1419fc2f&scoped=true"
import script from "./Template.vue?vue&type=script&setup=true&lang=js"
export * from "./Template.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Template.vue?vue&type=style&index=0&id=1419fc2f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1419fc2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1419fc2f')) {
      api.createRecord('1419fc2f', component.options)
    } else {
      api.reload('1419fc2f', component.options)
    }
    module.hot.accept("./Template.vue?vue&type=template&id=1419fc2f&scoped=true", function () {
      api.rerender('1419fc2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/preventive-maintenance/templates/Template.vue"
export default component.exports